module.exports = __webpack_public_path__ + "img/bentley-a3.66f724c5.jpg";